import { DietPlanActionsTypes } from "../constants/actionTypes"
import { IUserMealPlan } from "../interfaces/api/ambrosia/fetchUserMealPlan"

function init(): IUserMealPlan {
	return null
}
export const dietPlanReducer = function (state = init(), action: any) {
	switch (action.type) {
		case DietPlanActionsTypes.UPDATE_DIET_PLAN_TO_STORE: {
			return action?.payload === undefined ? null : action?.payload
		}
		case DietPlanActionsTypes.DELETE_DIET_PLAN_FROM_STORE: {
			return init()
		}
		default:
			return state
	}
}
